import { Eye } from 'lucide-react';
import { useWorkspaceStore } from '@/stores/workspace-store';
import { useGlobalSchemaStore } from '../global-schema-store';
import { walkViews, connectionLabel } from './_schema-helpers';
import type { SearchItem, SearchProvider } from '../types';
import type { ConnectionConfig } from '@/types';

export const viewSearchProvider: SearchProvider = {
  id: 'views',
  kind: 'view',
  list: (ctx) => {
    const schemas = useGlobalSchemaStore.getState().schemas;
    const connections = ctx.queryClient?.getQueryData<ConnectionConfig[]>(['connections']) ?? [];
    const items: SearchItem[] = [];

    for (const loc of walkViews(schemas)) {
      const connName = connectionLabel(connections, loc.connectionId);
      items.push({
        id: `view:${loc.connectionId}:${loc.database}:${loc.schema}.${loc.view.name}`,
        kind: 'view',
        label: loc.view.name,
        subtitle: `View · ${loc.schema} · ${loc.database} · ${connName}`,
        icon: Eye,
        boost: 0.9,
        action: () => {
          // Views open in a table tab (same grid, SELECT * under the hood)
          const tabId = `table:${loc.connectionId}:${loc.schema}.${loc.view.name}`;
          useWorkspaceStore.getState().openTab({
            type: 'table',
            id: tabId,
            connectionId: loc.connectionId,
            database: loc.database,
            schema: loc.schema,
            table: loc.view.name,
            where: '',
            orderBy: '',
          });
        },
      });
    }

    return items;
  },
};
